define('views/blocks/paymentModeProviders/CVCView',['app','PaymentModeSelectionBoardView',
        'InputView',
        'template!blocks/paymentmodes/cvc',
    ],function(app,PaymentModeSelectionBoardView,
    InputView,
    cvcTemplate
   ){
    return PaymentModeSelectionBoardView.extend({
        useSubmitButton:true,
        name:'cvc',
        classlist:'payment-mode__selection__form--simple',
        renderInner:function(){
            var paymentMode = this.paymentMode;
            return cvcTemplate({
                title: paymentMode.getParam('cvc_title'),
                label: paymentMode.getParam('cvc_label'),
                cvc:paymentMode.getOption('cvc','',true)
            });
        },
        submitForm:function(e){
            var view = this,
                cvc = ''+view.$('[name=cvc]').val(),
                paymentMode = view.paymentMode;
            if(cvc!==''){
                paymentMode.setOption('cvc',cvc,true);
                this.close();
            }
            return false;
        }
    });
});
